<script>

import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {ExclamationIcon, XIcon} from "@heroicons/vue/outline";
import SpeakerCard from "./SpeakerCard.vue";
export default {
  components: {
    SpeakerCard,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    ExclamationIcon,
    XIcon,
  },

  emits: ["close"],

  props: {
    scrollToSection: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    speakers: {
      type: Array,
      default: [],
    }
  },
  data() {
  },
  computed: {
    reversedSpeakers() {
      const reversedSpeakers = [...this.speakers];
      return reversedSpeakers.reverse();
    }
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<template>
  <TransitionRoot as="template" :show="open">
    <Dialog
      as="div"
      static
      class="fixed inset-0 z-10 overflow-hidden"
      @close="close"
      :open="open"
    >
      <!-- Background overlay -->
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75" />
      </TransitionChild>

      <!-- Bottom-aligned container -->
      <div class="fixed inset-x-0 bottom-0 justify-center max-w-[1340px] lg:mx-auto md:mx-[20px] h-[80%]">
        <TransitionChild
          as="template"
          enter="transition ease-out duration-300"
          enterFrom="translate-y-full"
          enterTo="translate-y-0"
          leave="transition ease-in duration-200"
          leaveFrom="translate-y-0"
          leaveTo="translate-y-full"
        >
          <div class="bg-[#F5F5F5] rounded-t-[20px] shadow-xl flex flex-col h-full lg:px-[70px] md:px-[30px] px-[10px] pt-[10px] lg:pt-[20px]">
            <div class="lg:mb-3 md:mb-2 mb-1 text-right">
              <button
                type="button"
                class="text-gray-400 self-end transition-all mr-[18px] duration-200 group hover:opacity-80 hover:text-gray-500"
                @click="close"
              >
                <span class="sr-only">Close</span>
                <XIcon
                  class="lg:w-12 md:w-6 md:h-6 w-4 h-4 lg:h-12 duration-500 ease-in-out transform text-[#0F0F0F] group-hover:scale-110"
                  aria-hidden="true"
                />
              </button>
            </div>
            <div class="overflow-y-auto flex-1
          [&::-webkit-scrollbar]:w-2
    [&::-webkit-scrollbar-track]:rounded-full
    [&::-webkit-scrollbar-track]:bg-[#D4D4D4]
    [&::-webkit-scrollbar-thumb]:rounded-full
    [&::-webkit-scrollbar-thumb]:bg-black
">
            <div class="grid-cols-2 md:grid-cols-4 grid gap-2 lg:gap-6 pb-2 lg:mr-5 mr-1">
            <SpeakerCard
              v-for="(speaker, j) in reversedSpeakers"
              :key="j"
              :speaker="speaker"
            />
            </div>
          </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>


<style>
/* If you're using <style scoped>, you may need to remove it or use a global style,
   because scoped styles can break custom scrollbar selectors. */

.custom-scrollbar {
  /* For Firefox */
  scrollbar-width: thin;                /* Makes the scrollbar a bit thinner */
  scrollbar-color: #000000 #d4d4d4;     /* thumb color #000, track color #d4d4d4 */
}

.custom-scrollbar::-webkit-scrollbar {
  width: 10px;              /* Scrollbar width */
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #d4d4d4;      /* Track color */
  border-radius: 9999px;    /* Makes the track pill-shaped */
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #000000;      /* Thumb color */
  border-radius: 9999px;    /* Makes the thumb pill-shaped */
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #444444;      /* Slightly lighter on hover */
}
</style>
